<template>
    <v-container style="max-width:100%;background-color:rgba(229, 229, 229, 0.3)">
        <v-row>

            <v-col class="align-center d-flex" :class="{
                'ml-0 justify-center': $vuetify.breakpoint.smAndDown, 'ml-16 justify-start': $vuetify.breakpoint.mdAndUp
            }">
                <img :src="require('@Base/assets/umivale_activa_hor_con_suma.svg')" alt="Umivale Activa"
                    imageClass="responsive" />
            </v-col>
            <v-col :cols="$vuetify.breakpoint.mdAndUp ? 6 : 12" class="d-flex align-center" :class="{
                'pr-16 justify-end': $vuetify.breakpoint.mdAndUp,
                'justify-center pt-0': $vuetify.breakpoint.smAndDown
            }" style="font-size: 14px !important;">
                <a v-for="(link, index) in [
                    { text: 'Aviso legal', href: 'https://umivaleactiva.es/legal/aviso-legal-solicitudes' },
                    { text: 'Protección de datos', href: 'https://umivaleactiva.es/protecciondatos' },
                    { text: 'Accesibilidad', href: 'https://umivaleactiva.es/legal/accesibilidad' }
                ]" :key="index" :href="link.href" target="_blank" class="pl-2" style="color: #124D91 !important">
                    {{ link.text }}
                </a>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'Footer',
    data() {
        return {
        }
    }
}
</script>
<style></style>


